module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_DavidHwang-5177938716cae02b7395e183ac6f9edb.png";